import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { LocationsService } from "../../locations-map/services/Locations.service";
import { MapHelperService } from "src/services/map-helper.service";
import { TurfHelperService } from "src/services/turf-helper.service";
import { FeatureCollection, Point, Polygon } from "@turf/turf";

@Injectable({
  providedIn: "root",
})
export class PanelAddGeofencesService {
  public $guidEditable: string = "";
  public $isDuplicate: boolean = false;
  private isVisibleControlSliderRadio$: Subject<boolean> = new Subject<boolean>();
  private intersectedFeatures$: Subject<any> = new Subject<any>();

  selectedFeatures: FeatureCollection<Polygon> = { type: "FeatureCollection", features: [] };

  constructor(private locationService: LocationsService) {
  }

  getVisibleControlSliderRadio(): any {
    return this.isVisibleControlSliderRadio$.asObservable();
  }

  setVisibleControlSliderRadio(resp){
    this.isVisibleControlSliderRadio$.next(resp);
  }
  
  getIntersectedFeatures(): any {
    return this.intersectedFeatures$.asObservable();
  }

  setIntersectedFeatures(resp){
    this.intersectedFeatures$.next(resp);
  }

  findByIdentifier(identifier): any {
    return this.locationService.findByIdentifier(identifier);
  }
}
